// Group-entry state mirrored into the URL; one home for the names so the writers can't drift.
export const GROUP_SIDEBAR_QUERY_PARAM = 'groupSidebar';
export const GROUP_SEARCH_QUERY_PARAM = 'groupSearch';
